import { NgModule } from '@angular/core';
import { AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';

// Services
import { PlacesSearch } from './core/services/places-search/places-search';

// components
import { MapComponent } from './core/components/map/map.component';
import { HomeComponent } from './core/components/home/home.component';
import { ToastComponent } from './core/components/toast/toast.component';
import { AroundMeComponent } from './core/components/around-me/around-me.component';
import { CityDropdownComponent } from './core/components/city-dropdown/city-dropdown.component';
import { CategorySelectComponent } from './core/components/category-select/category-select.component';
import { FullLayoutComponent } from './core/components/layouts/full-layout/full-layout.component';

// Plugins
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

// Shared Preferences
import { SharedPreferencesService } from './core/services/shared-preferences.service';

//Pipes
import { SanitizeUrl } from './core/pipes/sanitize-url';
import { SanitizeStyle } from './core/pipes/sanitize-style';

//Directives
import { GetMapObjectsDirective } from './core/directives/get-map-object';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    FullLayoutComponent,
    AroundMeComponent,
    CityDropdownComponent,
    CategorySelectComponent,
    MapComponent,
    ToastComponent,
    SanitizeUrl,
    SanitizeStyle,
    GetMapObjectsDirective
  ],
  imports: [
    BrowserModule.withServerTransition({appId: 'little-black-book'}),
    FormsModule,
    AgmCoreModule.forRoot({
      apiKey: environment.google_maps_api_key
    }),
    AppRoutingModule,
    HttpModule,
    AgmSnazzyInfoWindowModule,
    AgmJsMarkerClustererModule,
    BsDropdownModule.forRoot(),
    TypeaheadModule.forRoot()
  ],
  entryComponents: [
    HomeComponent
  ],
  providers: [
    PlacesSearch,
    SharedPreferencesService,
    GoogleMapsAPIWrapper
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/jaswantsingh/Documents/GitHub/maps/src/app/app.module.ts